<template lang="pug">
.tab.flex_v(:class="{ selected: selected }")
  img(:src="img")
  h5.i_mt_1.i_md_2.i_mt_sm_1 {{ title }}
</template>

<script>
import MediaImg from "@/components/common/MediaImg";

export default {
  name: "Tab",
  props: {
    title: String,
    img: String,
    selected: Boolean,
  },
  components: {
    "media-img": MediaImg,
  },
  data() {
    return {
      // selected: Boolean,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/about_us/tab";
</style>
